(() => {
  if (customElements.get('ao-care-disclosure')) return;

  customElements.define('ao-care-disclosure', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details || !this.summary) return;
      this.expanded = this.details.open;
      this.abort = new AbortController();
      this.syncState();
      this.summary.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggle(!this.expanded);
      }, { signal: this.abort.signal });
      // A changed viewport must never leave the content clipped to an old height.
      window.addEventListener('resize', () => this.finish(), { signal: this.abort.signal });
    }

    syncState() {
      this.dataset.expanded = String(this.expanded);
      this.summary.setAttribute('aria-expanded', String(this.expanded));
    }

    cancelAnimation() {
      if (!this.animation) return;
      this.animation.onfinish = null;
      this.animation.cancel();
      this.animation = null;
    }

    finish() {
      this.cancelAnimation();
      if (!this.details) return;
      this.details.open = this.expanded;
      this.details.style.overflow = '';
      this.syncState();
    }

    toggle(expanded) {
      // Measure before cancelling so a reversed animation starts where it is now.
      const start = this.details.getBoundingClientRect().height;
      this.cancelAnimation();
      this.expanded = expanded;
      this.syncState();
      if (!this.details.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.finish();
        return;
      }

      this.details.open = true;
      const style = getComputedStyle(this.details);
      const border = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
      const end = expanded
        ? this.details.getBoundingClientRect().height
        : this.summary.getBoundingClientRect().height + border;
      this.details.style.overflow = 'hidden';
      this.animation = this.details.animate(
        { height: [`${start}px`, `${end}px`] },
        { duration: 280, easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)' }
      );
      this.animation.onfinish = () => this.finish();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.finish();
    }
  });
})();
